import { useEffect, useState } from "react";
import loadBackboneApp from "../../../../app/load-backbone-app";
import { useParams } from "react-router-dom";
import { AlertMainLayoutView } from "../../../../app/components/alertmanager/alertmanager";
import { isUserAdmin } from "../../../../core/user-management/update.control";
import api from "../../../../core/api/api";
import metaStoreService from "../../../../core/services/metaStoreService/meta-store-service";
import Backbone from "backbone";
import AlertManagerRoot from "../alert-manager-root";
import AlertPermissionDenied from "./alert-permission-denied";

function AlertManagerDetails() {
    // @ts-ignore
    const { tab, category, item } = useParams();
    const isAdmin = isUserAdmin();
    const [permissionDenied, setPermissionDenied] = useState(false);

    useEffect(() => {
        if (!isAdmin) {
            api.getAlertingStatus()
                .done(status => {
                    if (!status["Alerting-permission"]) {
                        setPermissionDenied(true);
                        return;
                    }
                    loadAlertManager();
                })
                .fail(() => setPermissionDenied(true));
        } else {
            loadAlertManager();
        }
    }, [tab, category, item]);

    function loadAlertManager() {
        const safeCall = (promise) => Promise.resolve(promise).catch(() => null);
        const promises = [
            metaStoreService.fetchCollection(metaStoreService.entities.SYSALERTRULE),
            safeCall(api.getEmailConfigStatus()),
            safeCall(api.getSlackConfigStatus()),
            safeCall(api.getTeamsConfigStatus())
        ];

        Promise.all(promises).then(results => {
            const [alertCollection, emailConfigStatus, slackConfigStatus, teamsConfigStatus] = results;
            const adminOnlyTabs = ["smart_alerts", "nodes"];
            const resolvedTab = (!isAdmin && adminOnlyTabs.includes(tab)) ? "apps" : tab || (isAdmin ? "smart_alerts" : "apps");
            const pageModel = new Backbone.Model({
                tab: resolvedTab,
                category: category || null,
                item: item || null,
                isLiteMode: false,
                isAdmin: isAdmin,
                alertCollection: alertCollection,
                emailConfigStatus: emailConfigStatus || null,
                slackConfigStatus: slackConfigStatus || null,
                teamsConfigStatus: teamsConfigStatus || null
            });
            // @ts-ignore
            loadBackboneApp(new AlertMainLayoutView({ model: pageModel }));
        });
    }

    if (permissionDenied) {
        return <AlertPermissionDenied />;
    }

    return <></>;
}

export default function() {
    return (
        <AlertManagerRoot>
            <AlertManagerDetails />
        </AlertManagerRoot>
    );
}
